<div class="details-panel flex h-full w-full flex-col overflow-hidden">
  @if (node()) {
    <div class="panel-header flex flex-none items-start justify-between bg-white px-6 py-6">
      <div class="min-w-0 flex-1 pr-4">
        <h2 class="text-md truncate font-bold leading-tight text-gray-900" [title]="displayTitle()">
          {{ displayTitle() }}
        </h2>
        <div>
          @if (displayType() === 'procedure' && procedureCategoryColor()) {
            <button
              [matMenuTriggerFor]="categoryMenu"
              class="inline-flex cursor-pointer items-center gap-1.5 rounded-md bg-white px-2.5 py-1 text-xs font-medium text-gray-700 transition-colors hover:bg-gray-50"
            >
              <dojo-icon icon="arrow-right" [size]="'xs'" class="text-gray-400" matTooltip="Procedure"></dojo-icon>
              <span
                class="inline-block h-3 w-3 rounded-full"
                [style.background-color]="procedureCategoryColor()"
              ></span>
              {{ procedureCategoryLabel() | titlecase }}
              <dojo-icon icon="circle-info" [size]="'xs'" class="ml-0.5 opacity-40"></dojo-icon>
            </button>
            <mat-menu #categoryMenu="matMenu" class="no-width-constraints">
              <div class="w-[560px] p-4" (click)="$event.stopPropagation()">
                <div class="mb-3 text-sm font-semibold text-gray-900">Procedure Categories</div>
                <table class="w-full text-left text-xs">
                  <tbody>
                    @for (cat of procedureCategories; track cat.name) {
                      <tr class="border-b border-gray-100 last:border-0">
                        <td class="py-2 pr-3 align-top">
                          <div class="flex items-center gap-1.5">
                            <span
                              class="inline-block whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium"
                              [style.background-color]="cat.color"
                            >
                              {{ cat.name | titlecase }}
                            </span>
                            @if (cat.name === procedureCategoryLabel()) {
                              <dojo-icon icon="circle-check" [size]="'xs'" class="text-green-500"></dojo-icon>
                            }
                          </div>
                        </td>
                        <td class="py-2 align-top">
                          <div class="text-gray-700">{{ cat.description }}</div>
                          <div class="mt-0.5 text-gray-400">{{ cat.topics }}</div>
                          <div class="mt-1 rounded bg-gray-100 px-2 py-1 font-mono text-gray-600">
                            <markdown [data]="cat.example" [katex]="true" [katexOptions]="katexOptions"></markdown>
                          </div>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </mat-menu>
          } @else {
            <span
              class="inline-flex rounded-full px-2.5 py-0.5 text-xs font-medium text-neutral-700"
              [style.background-color]="badgeColor()"
            >
              {{ displayType() | titlecase }}
            </span>
          }
        </div>
      </div>
      <dojo-icon-button
        [icon]="'times'"
        (click)="closePanel.emit()"
        class="-mt-1 text-gray-400 hover:text-gray-600"
      ></dojo-icon-button>
    </div>

    <div class="panel-content flex-1 overflow-y-auto bg-white">
      @switch (nodeType()) {
        @case ('tag') {
          @if (tagNode(); as tag) {
            <exam-tag-details
              [data]="tag"
              [tagsMap]="tagsMap()"
              (navigateToNode)="navigateToNode.emit($event)"
            ></exam-tag-details>
          }
        }
        @case ('representation') {
          @if (representationNode(); as repr) {
            <exam-representation-details
              [data]="repr"
              [isRoot]="isRoot()"
              [runtimeValue]="runtimeValue()"
              [rootRepresentationIds]="rootRepresentationIds()"
              [sourceProcedures]="sourceProcedures()"
              [runtimeState]="runtimeState()"
              [representationsMap]="representationsMap()"
              (execute)="onExecute($event)"
              (navigateToNode)="navigateToNode.emit($event)"
              (autoExecuteRoot)="autoExecuteRoot.emit()"
            ></exam-representation-details>
          }
        }
        @case ('procedure') {
          @if (procedureNode(); as proc) {
            <exam-procedure-details
              [data]="proc"
              [representationsMap]="representationsMap()"
              (navigateToNode)="navigateToNode.emit($event)"
            ></exam-procedure-details>
          }
        }
        @default {
          <div class="p-4">
            <p class="text-gray-500">Unknown node type: {{ nodeType() }}</p>
          </div>
        }
      }
    </div>
  }
</div>
